import { ModelType } from '@/enums/model-type.enum';
import { LTX_23_LORA_MODEL } from './lora-input-models.const';
import { KREA_3_MODEL } from './krea-3.const';

export const COSMOS_3_SUPER_MODELS = new Set([
  'nvidia/cosmos-3-super/text-to-image',
  'nvidia/cosmos-3-super/image-to-video',
]);

/** Models whose size dropdown reads Fal's preset slugs, so they need the readable labels below. */
export const FAL_ASPECT_RATIO_LABEL_MODELS: ReadonlySet<string> = new Set([
  ...COSMOS_3_SUPER_MODELS,
  LTX_23_LORA_MODEL,
  ModelType.GptImage25,
  KREA_3_MODEL,
]);

// Fal's preset slugs are orientation-prefixed: portrait_4_3 is a 3:4 frame, not 4:3.
export const FAL_ASPECT_RATIO_LABELS: Record<string, string> = {
  square_hd: 'Square HD',
  square: 'Square',
  portrait_4_3: 'Portrait 3:4',
  portrait_16_9: 'Portrait 9:16',
  landscape_4_3: 'Landscape 4:3',
  landscape_16_9: 'Landscape 16:9',
};

/** Display text for stored resolution tokens; the option value sent to the server stays the token. */
export const RESOLUTION_OPTION_LABELS: Readonly<Record<string, string>> = {
  '768sq': '768x768',
};
